
import { mapActions, mapState } from "vuex";
import LocationOnlineStatusHandler from "../reciever/location-online-status-handler.vue";
import moment from "moment";

export default {
  components: { LocationOnlineStatusHandler },
  data() {
    return {
      valid: false,
      saveLoading: false,
      workingDays: [],
      IsWorkingDayChecked: [],
      time: null,
      timeDialog: false,
      selectedIndex: null,
      selectedTimeType: null,
      timeIntervals: []
    };
  },
  props: {
    isAppStoreReceiver: {
      type: Boolean,
      default: false
    },
    selectedRestaurant: {
      type: Object,
      default: {}
    }
  },
  created() {
    this.populateSlots();
  },
  mounted() {
    this.workingDays = [];
    for (let i = 0; i < 7; i++) {
      const found = this.selectedRestaurant.working_days.find(
        (el) => el.day == this.$constants.Days.DAYS_LONG[i]
      );
      if (found) {
        this.workingDays.push({
          id: found.id,
          day: found.day,
          events: [{ opens: found.opens, end: found.closes }],
          isChecked: true
        });
      } else {
        this.workingDays.push({
          day: this.$constants.Days.DAYS_LONG[i],
          events: [{ opens: null, end: null }],
          isChecked: false
        });
      }
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    }
  },
  methods: {
    ...mapActions("restaurant", ["updateRestaurantAvailabilityTiming"]),
    populateSlots() {
      const restaurantStartTime = 0;
      const restaurantEndTime = 24;
      const restaurantSlotDuration = 30;
      const totalSlots =
        (restaurantEndTime - restaurantStartTime) *
        (60 / restaurantSlotDuration);
      for (let i = 0; i < totalSlots; i++) {
        let slot = moment(`${restaurantStartTime}`)
          .add(restaurantSlotDuration * i, "minutes")
          .format("hh:mm A");
        this.timeIntervals.push(slot);
      }
    },
    showTimePickerDialog(index, type) {
      this.selectedIndex = index;
      this.selectedTimeType = type;
      this.time = this.convertTime12to24(this.workingDays[index][type]);
      this.timeDialog = true;
    },
    timeSelected() {
      this.workingDays[this.selectedIndex][this.selectedTimeType] =
        this.convertTime24to12(this.time);
      this.timeDialog = false;
    },
    handleSave() {
      this.saveLoading = true;
      let availability = [];
      this.workingDays.forEach((el, index) => {
        if (el.events?.length && el.events[0].opens && el.events[0].closes) {
          availability.push({ day: el.day, events: el.events });
        }
      });
      this.updateRestaurantAvailabilityTiming({ availability })
        .then((response) => {
          if (response.data.status === "success") {
            this.$nuxt.$emit("show-toast", {
              text: "Restaurant timing updated successfully",
              color: "success darken-2",
              icon: "done",
              flat: true
            });
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    handleAddSlot(index) {
      this.workingDays[index].events.push({ opens: null, end: null });
    },
    handleDeleteSlot(index, i) {
      this.workingDays[index].events.splice(i, 1);
    }
  }
};
